import React, { Component } from "react";
import InputText from "../../../../../common/components/input-text/input-text";
import Button from "../../../../../home/button-classic/button-classic";
import { getCookie } from "../../../../../utils/cookies.js";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import ACTION from "../../../../../common/action_constant";
import Switch from "react-switch";
import { validationCheck } from "../../../../../utils/validate";
import { GoVerified } from "react-icons/go";
import { IoIosWarning } from "react-icons/io";
import moment from 'moment';
import actions from "../../../../../common/action_constant";


class AddItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: JSON.parse(getCookie("user")).company_id,
      user_id: JSON.parse(getCookie("user")).user_id,
      user_name: JSON.parse(getCookie("user")).name,
      driver_name: "",
      cell_no: "",
      dl_no: "",
      dob: "",
      driver_acc_no: "",
      driver_ifsc_code: "",
      driver_alternative_location_id: "",
      driver_detail_validity_date: "",
      preferredroute: [],
      dlName: '',
      is_blocked: false,
      block_remarks: "",
      blocked_by: "",
      errorMsg: "",
      fetchbuttonclicked: false,
      isVerifyingDL: false,
      isOcrVerifying: false,
      dlValidationStatus: {
        isValid: "",
        validationMessage: "",

      }
    };
  }
  componentDidMount() { }
  handleChange = (id, selectedOption) => {
    this.setState({ [id]: selectedOption.label });
  };
  validateCheck = () => {
    const { driver_name, cell_no, dl_no, dob, driver_detail_validity_date, dlName } = this.state;
    if (driver_name && cell_no && dl_no && driver_detail_validity_date && dob && dlName) {
      return true;
    } else return false;
  };

  onSave = () => {
    const data = this.state;
    const { fetchbuttonclicked, driver_detail_validity_date, dob } = this.state;

    if (!this.validateCheck()) {
      this.setState({
        errorMsg: "Please add all mandatory fields",
      });
      return;
    }
    const hasMaskedData =
      [data.driver_name, data.cell_no, data.driver_alternative_location_id]
        .filter(Boolean)
        .some((field) => field.includes("*"));

    if (hasMaskedData) {
      this.setState({
        errorMsg:
          "Some fields contain masked (*) data. Please enter complete driver details before saving.",
      });
      return;
    }
    if (!fetchbuttonclicked) {
      this.setState({
        errorMsg:
          "Please fetch driver details before saving.",
      });
      return;
    }

    const today = moment().startOf("day");

    if (
      !driver_detail_validity_date ||
      moment(driver_detail_validity_date).isBefore(moment().startOf("day"))
    ) {
      this.setState({
        errorMsg: "Please select a valid Driving Licence Validity Date.",
      });
      return;
    }

    if (dob && moment().diff(moment(dob), "years") < 18) {
      this.setState({
        errorMsg: "Driver must be at least 18 years old.",
      });
      return;
    }
    // ✅ Proceed with save
    this.setState({ errorMsg: "" }); // clear old errors
    this.props.toggleAdd();
    this.props.addDriverInfo(data);
  };

  addLocation = () => {
    let { preferredroute } = this.state;
    preferredroute.push({ source: "", destination: "" });
    this.setState({ preferredroute });
  };
  deleteLocation = (index) => {
    const { preferredroute } = this.state;
    preferredroute.splice(index, 1);
    this.setState({ preferredroute });
  };

  SelectDate = (id, selectedOption) => {
    this.setState({ [id]: selectedOption.valueOf() });
  };

  onChangeHandler = (value, id, isType) => {
    if (id === 'driver_ifsc_code' || id === 'dl_no') {
      value = value.replace(/[^A-Za-z0-9]/g, '');
      value = value.slice(0, 16);
    }
    const result = validationCheck(value, this.state[id], isType);
    this.setState({ [id]: result });
  }

  uploadfiles = (e, name) => {
    const { dispatch } = this.props;
    const { driverinfo } = this.state;
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch({
      type: ACTION.DATA_GOVERNANCE.UPLOAD_VEHICLE_FIELS,
      formData,
      uploadFromDriverPopup:true,
      onSuccess: (data) => {
        this.setState({ [name]: data });
      },
    });
  };

    handleFileClickWithpresignedUrl = (name = "") => {

    const { dispatch } = this.props;

    dispatch({

      type: actions.HOME.GET_PRESIGNED_DOWNLOAD_URL,

      fileName: name,
      trip_id: "",
      method_name: "",

      onSuccess: ((link) => {

        console.log("link", link);

        window.open(link, '_blank');

      })

    })

  }
 
  FetchDriverDetails = () => {
    const { dispatch } = this.props;
    const { dl_no, dob } = this.state;
    // Format DOB to YYYY-MM-DD
    const dateObj = new Date(dob);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    const formattedDob = `${year}-${month}-${day}`;

    const data = { dlnumber: dl_no, dob: formattedDob };
   this.setState({
      fetchbuttonclicked: true,
      isVerifyingDL: true,   // ⬅️ show loader
      dlValidationStatus: { isValid: "", validationMessage: "" }
    })
    dispatch({
      type: ACTION.MASTER.VEHICLE_PLANNING.DRIVER_DETAILS_FROM_ULIP,
      queryParams: data,
      onSuccess: (response) => {
        let validationStatus = {
          isValid: "",
          validationMessage: ""
        }
        const dlData =
          response?.data?.response?.dldetobj?.[0] || null;

        if (dlData && (dlData.dlobj?.dlLicno || dlData.bioObj?.bioDlno)) {
          // DL number exists
          validationStatus.isValid = "success";
          validationStatus.validationMessage = "DL number is valid"

          const driverName =
            dlData.bioObj?.bioFullName ||
            dlData.dlobj?.bioFirstName ||
            "";
          const driverContact =
            dlData.bioObj?.bioMobileNo ||
            "";
          const driverLocation =
            dlData.bioObj?.bioPermAdd1 + dlData.bioObj?.bioPermAdd2 + dlData.bioObj?.bioPermAdd3 ||
            dlData.bioObj?.bioTempAdd1 + dlData.bioObj?.bioTempAdd2 + dlData.bioObj?.bioTempAdd3 ||
            "";
          const driverDLValidityDate = dlData.dlobj?.dlNtValdtoDt
            ? moment(dlData.dlobj.dlNtValdtoDt, "YYYY-MM-DD").valueOf()
            : "";

          let driverCovDesc = [];
          if (dlData.dlcovs && dlData.dlcovs.length > 0) {
            driverCovDesc = dlData.dlcovs;
          }

          // ✅ Autofill the fields
          this.setState({
            isVerifyingDL: false ,
            dlValidationStatus: validationStatus,
            driver_name: driverName,
            cell_no: driverContact,
            driver_alternative_location_id: driverLocation,
            driver_detail_validity_date: driverDLValidityDate,
            driverCovDesc
          });
          console.log("a:",driverCovDesc)
        } else {
          // DL number not found
          validationStatus.isValid = "error";
          validationStatus.validationMessage = "DL number does not exist"
        }
        this.setState({
          dlValidationStatus: validationStatus,
          isVerifyingDL: false
        });
      },
    });
  };

  onUpload = () => {
    this.uploadUrl.click();
  };

  onChange = (e) => {
    const file = e.target.files[0];
    this.uploadfiles(e, "dlName");   // existing logic
    if (file) {
      this.FeatchOcrDetails(file);   // send file to API
    }
  };

  handleOcrSuccess = (resp) => {
    const data = resp?.data || {};
    const scannedDl = data.dl_number?.trim();
    const enteredDl = this.state.dl_no?.trim();   // <-- your input value

    // 1️⃣ INVALID OCR
    if (!data || resp?.document_type === "UNKNOWN") {
      this.setState({
        ocrError: "Please upload a valid DL image",
      });
      return;
    }

    // 2️⃣ DL NUMBER MISMATCH
    if (scannedDl !== enteredDl) {
      this.setState({
        ocrError: "DL number in the image does not match the entered DL number.",
      });
      return;
    }

    // 3️⃣ SUCCESS
    this.setState({
      ocrError: "", // remove previous errors
      driver_name: data.name || "",
      driver_detail_validity_date: data.validity_tr
        ? moment(data.validity_tr, "YYYY-MM-DD").valueOf()
        : "",
      driver_alternative_location_id: data.address || "",
    });

    console.log("OCR Auto filled data", data);
  };


  FeatchOcrDetails = (file) => {
    const { dispatch } = this.props;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("docs_type", "dl");

      this.setState({
    isOcrVerifying: true,
    });

    dispatch({
      type: ACTION.MASTER.VEHICLE_PLANNING.DRIVER_DETAILS_OCR,
      payload: formData,
      onSuccess: (resp) => {
      this.handleOcrSuccess(resp);

      // stop loader
      this.setState({ isOcrVerifying: false });
    },
    });
  };

  handleSwitch = (name) => (checked) => {

    this.setState({ is_blocked: checked });
  };
  render() {
    const { preferredroute, driverinfo, is_blocked } = this.state;
    const { driverCovDesc } = this.state;

    return (
      <div className="driver-modal">
        <div className="driver-backdrop" onClick={this.props.toggleAdd} />
        <div className="driver-card">
          <h2>Add Driver Info</h2>
          <div className="driver-grid">
            {/* FIRST ROW */}
            <div style={{ display: "flex", gap: "4px" }}>
              {/* DL */}
              <div style={{ flex: 1 }}>
                <InputText
                  label="DL No"
                  placeholder="DL No"
                  id="dl_no"
                  value={this.state.dl_no}
                  changeHandler={this.onChangeHandler}
                  length={"16"}
                  required
                  disabled={this.state.dlValidationStatus?.isValid === "success"}
                />
              </div>
              {/* DOB */}
              <div style={{ flex: 1, display: "flex", alignItems: "flex-end" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      fontSize: "13px",
                      color: "#868e96",
                      marginBottom: "6px"
                    }}
                  >
                    Driver DOB <span style={{ color: "red" }}>*</span>
                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.dob}
                    onChange={this.SelectDate.bind(this, "dob")}
                    disabled={this.state.dlValidationStatus?.isValid === "success"}
                    placeholderText="DD/MM/YYYY"
                    maxDate={new Date()}
                    popperPlacement="bottom-start"
                    style={{
                      width: "4px",
                      borderRadius: "8px",
                      border: "1px solid #dee2e6",
                      padding: "10px 12px",
                      fontSize: "15px",
                      outline: "none"
                    }}
                  />
                </div>

                <button
                  style={{
                    background: this.state.dlValidationStatus?.isValid === "success"
                      ? "#cccccc"     // 🔒 grey when frozen
                      : "#007bff",     // normal blue
                    color: "#fff",
                    padding: "10px 32px",
                    borderRadius: "6px",
                    cursor: this.state.dlValidationStatus?.isValid === "success"
                      ? "not-allowed"  // show disabled cursor
                      : "pointer",
                    border: "none",
                    height: "32px",
                    marginLeft: "4px"
                  }}
                  disabled={this.state.dlValidationStatus?.isValid === "success"} // 🔒 disable click
                  onClick={() => this.FetchDriverDetails()}
                >
                  Fetch
                </button>

              </div>
            </div>

            {this.state.isVerifyingDL && (
              <div
                style={{
                  marginTop: "8px",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  backgroundColor: "rgba(0,0,0,0.05)",
                  maxWidth: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  border: "1px solid #ccc"
                }}
              >
                <div className="spinner" style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #999",
                  borderTopColor: "transparent",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite"
                }}></div>
                <span style={{ fontSize: "14px" }}>Verifying DL...</span>
              </div>
            )}


            {this.state.dlValidationStatus.validationMessage && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "8px",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  backgroundColor:
                    this.state.dlValidationStatus.isValid === "success"
                      ? "rgba(0, 200, 83, 0.1)" // light green
                      : "rgba(244, 67, 54, 0.1)", // light red
                  border: `1px solid ${this.state.dlValidationStatus.isValid === "success"
                    ? "#4CAF50"
                    : "#F44336"
                    }`,
                  color:
                    this.state.dlValidationStatus.isValid === "success"
                      ? "#2E7D32"
                      : "#C62828",
                  fontSize: "14px",
                  fontWeight: 500,
                  maxWidth: "fit-content"
                }}
              >
                {this.state.dlValidationStatus.isValid === "success" ? (
                  <GoVerified style={{ fontSize: "18px", color: "#2E7D32" }} />
                ) : (
                  <IoIosWarning style={{ fontSize: "18px", color: "#C62828" }} />
                )}
                <span>{this.state.dlValidationStatus.validationMessage}</span>
              </div>
            )}
            <div className="upload-section">
              {/* Label */}
              <label className="upload-label">
                DL Image <span className="text-danger">*</span>
              </label>
              {/* Row container */}
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                {/* Upload Box */}
                <div
                  className="upload-box"
                  onClick={() => this.uploadUrl.click()}
                >
                  {/* Upload Arrow Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="#6c757d"
                    viewBox="0 0 24 24"
                    style={{ marginRight: "10px" }}
                  >
                    <path d="M12 3l4 4h-3v6h-2V7H8l4-4zm-7 14v2h14v-2H5z" />
                  </svg>
                  <span>Upload Image</span>
                </div>

                {/* Preview Box (same height, beside upload) */}
                {this.state.previewImage && (
                  <div
                    style={{
                      height: "60px",
                      width: "180px",
                      border: "1px solid #dee2e6",
                      padding: "10px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      background: "#f8f9fa",
                      position: "relative",
                    }}
                  >
                    {/* Remove Button */}
                    <span style={{ position: "absolute", top: "-8px", right: "-8px", background: "#ff6b6b", color: "white", width: "22px", height: "22px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", fontSize: "14px", fontWeight: "bold", }}
                      onClick={() =>
                        this.setState({
                          previewImage: null,
                          dlName: null,
                        })
                      }
                    >×</span>

                    <img
                      src={this.state.previewImage}
                      alt="DL Preview"
                      style={{
                        width: "52px",
                        height: "40px",
                        borderRadius: "6px",
                        objectFit: "cover",
                        border: "1px solid #ced4da",
                      }}
                    />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: "12px", color: "#495057" }}>
                        {this.state.dlName?.name}
                      </span>

                      {/* <a
                        href={this.state.previewImage}
                        download
                        style={{ fontSize: "12px", color: "#1c7ed6", marginTop: "4px" }}
                      > */}
                        {/* Download */}
                      {/* </a> */}
                      <div
                        className="fs-12 mt-5 curP"
                        onClick={() =>
                          this.handleFileClickWithpresignedUrl(this.state.dlName?.name)
                        }
                      >
                        {this.state.dlName?.name}
                      </div>
                    </div>
                  </div>
                )}

              </div>

              {/* Hidden Input */}
              <input
                disabled={!this.state.fetchbuttonclicked}
                type="file"
                ref={(e) => (this.uploadUrl = e)}
                style={{ display: "none" }}
                accept=".jpeg, .jpg, .png"
                onChange={(e) => {
                  this.onChange(e);
                  const file = e.target.files[0];
                  if (file) {
                    this.setState({
                      previewImage: URL.createObjectURL(file),
                      dlName: { name: file.name, url: URL.createObjectURL(file) },
                    });
                  }
                }}
                onClick={(e) => (e.target.value = null)}
              />
            </div>
            {this.state.isOcrVerifying && (
              <div
                style={{
                  marginTop: "8px",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  backgroundColor: "rgba(0,0,0,0.05)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  maxWidth: "fit-content",
                  border: "1px solid #ccc"
                }}
              >
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    border: "2px solid #999",
                    borderTopColor: "transparent",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite"
                  }}
                ></div>
                <span>Processing OCR...</span>
              </div>
            )}

            {this.state.ocrError && (
              <div style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                {this.state.ocrError}
              </div>
            )}
             
            <div
              style={{
                marginTop: "12px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "4px",   // horizontal gap
                rowGap: "42px",      // vertical gap
              }}
            >
              <InputText
                label="Driver Name"
                id="driver_name"
                value={this.state.driver_name}
                placeholder="Driver Name"
                changeHandler={this.onChangeHandler}
                length={"45"}
                required
                disabled={!this.state.fetchbuttonclicked} 
              />
              <InputText
                label="Driver Contact"
                id="cell_no"
                value={this.state.cell_no}
                placeholder="Driver Contact"
                changeHandler={this.onChangeHandler}
                length={"10"}
                isValidate={"numeric"}
                required
                disabled={!this.state.fetchbuttonclicked}
              />
              <InputText
                label="Driver Location"
                id="driver_alternative_location_id"
                value={this.state.driver_alternative_location_id}
                placeholder="Driver Location"
                changeHandler={this.onChangeHandler}
                length={"45"}
                disabled={!this.state.fetchbuttonclicked}
              />
              <InputText
                label="Driver A/C No"
                id="driver_acc_no"
                value={this.state.driver_acc_no}
                placeholder="Driver A/C No"
                changeHandler={this.onChangeHandler}
                length={"17"}
                disabled={!this.state.fetchbuttonclicked}
              // required
              />
              <InputText
                label="IFSC"
                id="driver_ifsc_code"
                value={this.state.driver_ifsc_code}
                placeholder="IFSC"
                changeHandler={this.onChangeHandler}
                length={"11"}
                disabled={!this.state.fetchbuttonclicked}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={{
                  fontSize: "13px",
                  color: "#868e96",
                  marginBottom: "6px"
                }}>
                  DL validity date <span style={{ color: "red" }}>*</span>
                </label>
                <DatePicker
                  disabled={!this.state.fetchbuttonclicked}
                  dateFormat="dd/MM/yyyy"
                  selected={this.state.driver_detail_validity_date}
                  onChange={this.SelectDate.bind(
                    this,
                    "driver_detail_validity_date"
                  )}
                  placeholderText={"DD/MM/YYYY"}
                  // minDate={new Date()}
                  required
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    padding: "10px 12px",
                    fontSize: "15px",
                    outline: "none"
                  }}
                  popperPlacement="bottom-start"
                />
              </div>
            </div>

            {this.state.driverCovDesc?.length > 0 && (
              <div className="dl-types-card">
                <h3 className="dl-title">DL Types</h3>

                <div className="dl-table">

                  <div className="dl-row dl-header">
                    <div className="dl-col desc">Description</div>
                    <div className="dl-col endorsement">Endorsement</div>
                  </div>

                  {(this.state.driverCovDesc || []).map((item, idx) => (
                    <div key={idx} className="dl-row">
                      <div className="dl-col desc">{item.covdesc}</div>
                      <div className="dl-col endorsement">{item.dcEndorsedt}</div>
                    </div>
                  ))}

                </div>
              </div>
            )}


            <div className="location-wrapper">
              <div className="location-header">
                <h3>Add Location</h3>
                <button className="btn-add" onClick={this.addLocation}>+ Add</button>
              </div>
              {preferredroute.map((value, index) => (
                <div className="location-row" key={index}>
                  <div className="form-field">
                    <InputText
                      disabled={!this.state.fetchbuttonclicked}
                      label="Source"
                      placeholder="Source"
                      value={value.source}
                      changeHandler={(v) => {
                        let preferredroute = [...this.state.preferredroute];
                        preferredroute[index].source = v;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>

                  <div className="form-field">
                    <InputText
                      disabled={!this.state.fetchbuttonclicked}
                      label="Destination"
                      placeholder="Destination"
                      value={value.destination}
                      changeHandler={(v) => {
                        let preferredroute = [...this.state.preferredroute];
                        preferredroute[index].destination = v;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>

                  <button
                    className="btn-delete"
                    onClick={() => this.deleteLocation(index)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>

          </div>
            {this.state.errorMsg && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "8px",
                        padding: "8px 10px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                        border: "#F44336",
                        color: "#C62828",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >{this.state.errorMsg}</div>
                  )}
          <div className="driver-footer">
            <Button
              value="Cancel"
              className="btn-outline"
              click={this.props.toggleAdd}
            />

            <Button
              value="Save"
              className="btn-primary"
              click={this.onSave}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(AddItem);
